export default __webpack_public_path__ + "static/media/story.fa9ab6d1.PNG";